const en = {
  appName: 'Knowledge Hub',
  uploadFiles: 'Upload Files',
  upload: 'Upload',
  cancel: 'Cancel',
  dashboard: 'Dashboard',
  allFiles: 'All Files',
  fileBrowser: 'File Browser',
  starred: 'Starred',
  recent: 'Recent',
  tags: 'Tags',
  categories: 'Categories',
  trash: 'Trash',
  settings: 'Settings',
  help: 'Help',
  searchPlaceholder: 'Search orders, folders, files...',
  searchFilesPlaceholder: 'Search files...',
  search: 'Search',
  notifications: 'Notifications',
  expandSidebar: 'Expand sidebar',
  collapseSidebar: 'Collapse sidebar',
  profile: 'Profile',
  signOut: 'Sign out',
  language: 'Language',
  switchLanguage: 'Switch language',

  // Files page
  filesTitle: 'Files',
  filter: 'Filter',
  sort: 'Sort',
  sortName: 'Name',
  sortDate: 'Date',
  sortSize: 'Size',
  noFilesFound: 'No files found',
  noStarredTip: 'No starred files yet. Star important files to find them quickly.',
  fileType: {
    all: 'All Files',
    document: 'Documents',
    image: 'Images',
    video: 'Videos',
    audio: 'Audio',
    pdf: 'PDFs',
    spreadsheet: 'Spreadsheets',
    presentation: 'Presentations',
  },

  // Upload modal
  uploadTitle: 'Upload Files',
  uploadTo: 'Upload to',
  dropOrBrowse: 'Drag & drop files or folders here, or',
  browseFiles: 'Browse files',
  browseFolders: 'Browse folders',
  supportedTypesTip: 'Supported: documents, images, videos, etc.',
  uploadFromUrl: 'Upload from URL',
  urlPlaceholder: 'Enter file URL',
  filenamePlaceholder: 'Filename',
  uploading: 'Uploading...',
  selectedFiles: 'Selected files',
  uploadingProgress: 'Uploading {{processed}}/{{total}} ...',
  enterFileUrl: 'Please enter file URL',
  enterFilename: 'Please enter filename',
  uploadFailedPrefix: 'Upload failed: ',

  // Captcha
  captchaPlaceholder: 'Enter CAPTCHA',
  captchaInvalid: 'Invalid CAPTCHA, please try again',

  // File list
  fileListTitle: 'File List',
  generateThumbnails: 'Generate Thumbnails',
  processing: 'Processing...',
  processedStats: 'Processed {{processed}} / {{total}} files{{failed}}',
  failed: 'failed',
  headerName: 'Name',
  headerType: 'Type',
  headerSize: 'Size',
  headerModified: 'Modified',
  headerTags: 'Tags',
  headerActions: 'Actions',

  // Search modal
  searchModalPlaceholder: 'Search for documents, images, or any content...',
  searchBy: 'Search by:',
  tabAll: 'All',
  tabTags: 'Tags',
  tabType: 'File Type',
  tabCombined: 'Combined',
  filterByTags: 'Filter by tags:',
  filterByType: 'Filter by file type:',
  searchHelpStart: 'Start typing to search for files...',
  searchHelpHint: 'You can search by file name, content, tags, or file type',
  searchNoResultsFor: 'No results found for "{{query}}"',
  searchAdjust: 'Try adjusting your search terms or filters',
  viewAllResults: 'View all {{count}} results',
  resultsFoundSummary: '{{count}} results found',
  escToClose: 'Press ESC to close',
  arrowsToNavigate: '↑↓ to navigate, Enter to select',

  // Create category modal
  createCategory: {
    titleRoot: 'Create Category',
    titleSub: 'Create Subcategory',
    creatingUnder: 'Creating under',
    nameLabel: 'Category Name',
    namePlaceholder: 'Enter category name',
    cancel: 'Cancel',
    submit: 'Create Category',
    errorRequired: 'Category name is required',
    errorDuplicate: 'This name already exists under the same parent',
    duplicateNameHint: 'This name already exists at current level. Please change it.',
  },

  // File card & details
  moveTo: 'Move to…',
  delete: 'Delete',
  goBack: 'Go back',
  save: 'Save',
  downloadFile: 'Download file',
  renameFile: 'Rename file',
  uploadCustomThumbnail: 'Upload custom thumbnail',
  updateThumbnail: 'Update thumbnail',
  uploadThumbnail: 'Upload thumbnail',
  captureVideoFrameAsThumb: 'Set current frame as thumbnail',
  capturePdfPageAsThumb: 'Set current page as thumbnail',
  refreshThumbnail: 'Refresh thumbnail',
  refreshingThumbnail: 'Refreshing…',
  refreshThumbnailFailedPrefix: 'Failed to refresh thumbnail: ',
  thumbnailUrl: 'Thumbnail URL',
  fileUrl: 'File URL',
  description: 'Description',
  fileInformation: 'File Information',
  type: 'Type',
  created: 'Created',
  lastModified: 'Last Modified',
  size: 'Size',
  owner: 'Owner',
  deleteFileTitle: 'Delete File',
  deleteFileConfirm: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  confirmDelete: 'Delete',
  shareLinkCopied: 'Share link copied!',
  loadingImage: 'Loading image...',
  loadingPDF: 'Loading PDF...',
  loadingVideo: 'Loading video...',
  prevPage: 'Previous',
  nextPage: 'Next',
  pageIndicator: 'Page {{current}} of {{total}}',
  previewFallbackTip: 'Trying to load preview. If it fails, you can download the file to view locally or upload a custom thumbnail.',
  pleaseSelectValidImage: 'Please select a valid image file',
  videoThumbUpdated: 'Video thumbnail updated successfully. Click copy to get the latest URL',
  pdfThumbUpdated: 'PDF thumbnail updated successfully. Click copy to get the latest URL',
  thumbnailUrlCopied: 'Thumbnail URL copied',
  fileUrlCopied: 'File URL copied',
  cannotUploadThumbMissingStorage: 'Cannot upload thumbnail: missing storage info',
  uploadThumbnailFailedPrefix: 'Failed to upload thumbnail: ',
  onlyImageForThumbnail: 'Only image files are supported for thumbnails',
  allThumbnailsRefreshed: 'All thumbnails refreshed',
  thumbnailRefreshed: 'Thumbnail refreshed',
  thumbnailRefreshedButPartial: 'Thumbnail refreshed, but some errors occurred',
  fileNotFound: 'File not found',
  noPreviewAvailable: 'Preview not available for this file type. Please download to view locally.',
  officePreviewPoweredBy: 'Preview powered by Microsoft Office Online',
  loadingCode: 'Loading file content…',
  loadCodeFailed: 'Failed to load file content',
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit fullscreen',
  close: 'Close',

  // Categories page
  categoriesAll: 'All Categories',
  breadcrumbCategories: 'Categories',
  itemsSection: 'Items',
  createSubfolder: 'Create Subfolder',
  renameCategory: 'Rename',
  bulkActions: 'Bulk actions',
  exitSelection: 'Exit selection',
  moveCurrentCategory: 'Move current category',
  clearAndDeleteCategory: 'Clear and delete category',
  moveThisCategory: 'Move this category',
  clearAndDeleteThisCategory: 'Clear and delete this category',
  folder: 'Folder',
  filesLabel: 'files',
  more: 'More',
  selectAllFiles: 'Select all files',
  selectAllSubfolders: 'Select all subfolders',
  clearSelection: 'Clear selection',
  generateThumbnailsQuick: 'Generate thumbnails',
  deleteWithFolders: 'Delete (including folders)',
  deleteQuick: 'Delete',
  categoryNotFound: 'Category not found',
  moveToTitle: 'Move to',
  selectDestinationFolder: 'Select destination folder',
  pleaseConfirmMove: 'Please confirm move:',
  willMoveTheseItems: 'Will move the following {{count}} items:',
  next: 'Next',
  confirmMove: 'Confirm move',
  moving: 'Moving...',
  renameCategoryTitle: 'Rename Category',
  newName: 'New name',
  renameCategoryUniqueNote: 'Name must be unique under the same parent.',
  saving: 'Saving...',
  openClearAndDelete: 'Open clear and delete',
  confirmDeletionTitle: 'Confirm Deletion',
  selectedFoldersWarning: 'Selected {{count}} folders. For safety, please clear and delete these folders first.',
  deleteSelectionIntro: 'The following {{count}} files will be deleted:',
  andMore: '… and {{n}} more',
  deletingProgress: 'Deleting {{processed}}/{{total}}',
  deleteFilesAction: 'Delete files',
  clearAndDeleteCategoryTitle: 'Clear and Delete Category',
  clearConfirmFiles: 'This will delete all files ({{count}}) in the subtree of category "{{name}}", including all subfolders. Continue?',
  clearDeletingFiles: 'Deleting files in the category…',
  clearConfirmDeleteCategory: 'All files have been deleted. Delete category "{{name}}"?',
  deleteCategoryAction: 'Delete category',
  moveCategoryTitle: 'Move Category',
  selectNewParentFolder: 'Select new parent folder',
  pleaseConfirmMoveCategory: 'Please confirm move category:',
  categoryLabel: 'Category:',
  selectionSummary: 'Selected {{total}} (files {{files}} / folders {{folders}})',

  // Auth & login/register
  welcomeBack: 'Welcome back',
  noAccount: "Don't have an account?",
  signUp: 'Sign up',
  emailAddress: 'Email address',
  password: 'Password',
  signingIn: 'Signing in...',
  signInAction: 'Sign in',
  invalidEmailOrPassword: 'Invalid email or password',
  createAccount: 'Create an account',
  haveAccount: 'Already have an account?',
  confirmPassword: 'Confirm Password',
  creatingAccount: 'Creating account...',
  createAccountAction: 'Create account',
  emailRequired: 'Email is required',
  passwordRequired: 'Password is required',
  passwordsDoNotMatch: 'Passwords do not match',
  passwordMinLength: 'Password must be at least 6 characters long',
  unableToCreateAccount: 'Unable to create account. Please try again later.',
  failedToCreateAccount: 'Failed to create account',
  passwordWeak: 'Weak',
  passwordMedium: 'Medium',
  passwordStrong: 'Strong',
  passwordsMatch: 'Passwords match',
  checkEmailTitle: 'Check your email',
  checkEmailSubtitle: 'We sent a confirmation link. Keep this page open and confirm the email to continue.',
  confirmationEmailSentTo: 'Confirmation email sent to',
  openEmailToConfirm: 'Open the email and click Confirm Email.',
  autoRedirectAfterConfirm: 'After confirmation, this page will enter the portal automatically.',
  iveConfirmedContinue: "I've confirmed, continue",
  checkingConfirmation: 'Checking confirmation...',
  confirmationPendingNotice: 'No confirmed session detected yet. Please click the confirmation link in your email first.',
  confirmationCheckFailed: 'Unable to check the confirmation status. Please try again.',
  editEmail: 'Use another email',

  // Password reset
  forgotPassword: 'Forgot password?',
  resetPasswordTitle: 'Reset Password',
  resetPasswordDesc: 'Enter your email address and we will send you a password reset link.',
  sendResetLink: 'Send Reset Link',
  sendingResetLink: 'Sending...',
  resetEmailSent: 'Reset email sent! Please check your inbox.',
  resetEmailSentDesc: "If you don't see it, check your spam folder.",
  backToLogin: 'Back to Login',
  setNewPassword: 'Set New Password',
  setNewPasswordDesc: 'Please enter your new password.',
  newPassword: 'New Password',
  updatePasswordAction: 'Update Password',
  updatingPassword: 'Updating...',
  passwordResetSuccess: 'Password updated! Redirecting to login...',
  tryAgain: 'Try Again',

  // Magic Link / OTP login
  passwordLogin: 'Password',
  magicLinkLogin: 'Email Code',
  magicLinkDesc: 'Enter your email and we\'ll send you a verification code.',
  sendMagicLink: 'Send Code',
  sendingMagicLink: 'Sending...',
  magicLinkSent: 'Code sent!',
  magicLinkSentDesc: 'Check your inbox and enter the 6-digit code.',
  magicLinkError: 'Failed to send code. Please try again.',
  emailNotRegistered: 'This email is not registered. Please sign up first.',
  otpSentTo: 'Code sent to',
  otpVerifyAction: 'Verify & Sign In',
  otpVerifyError: 'Invalid or expired code. Please try again.',
  otpResend: 'Resend Code',
  otpChangeEmail: 'Change Email',
  otpPlaceholder: 'Enter code',
  otpResent: 'Sent',

  // Tags page
  tagsTitle: 'Tags',
  newTag: 'New Tag',
  allTags: 'All Tags',
  addTag: 'Add Tag',
  tagColor: 'Tag Color',
  filesWithThisTag: 'Files with this tag',
  noFilesWithThisTag: 'No files with this tag yet',
  selectTagToView: 'Select a tag to view associated files',
  deleteTagConfirm: 'Are you sure you want to delete this tag? This action cannot be undone.',

  // Trash page
  trashTitle: 'Trash',
  trashAutoDelete: 'Items in trash are automatically deleted after 30 days',
  emptyTrash: 'Empty Trash',
  trashEmpty: 'Trash is empty',
  noItemsInTrash: 'No items in trash',
  autoDeleteNotice: 'Items in trash will be automatically deleted after 30 days',
  restoreAll: 'Restore All',
  confirmEmptyTrash: 'Are you sure you want to permanently delete all items in the trash? This action cannot be undone.',

  // Dashboard page
  totalFiles: 'Total Files',
  categoriesLabel: 'Categories',
  recentlyUpdated: 'Recently Updated',
  viewAll: 'View All',
  noRecentFiles: 'No recent files. Start uploading content to see it here.',
  starredFilesTitle: 'Starred Files',
  quickAccess: 'Quick Access',
  viewManageAllFiles: 'View and manage all your files',
  accessImportantFiles: 'Access your important files',
  recentWorkedOn: "Files you've recently worked on",
  browseByCategory: 'Browse files by category',
  storageCardTitle: 'Storage',
  storageFull: 'Storage Full',
  storageWarning: 'Storage Warning',
  manageStorage: 'Manage Storage',
  used: 'Used:',
  total: 'Total:',
  others: 'Others',
  updatedLabel: 'Updated',
  addToStarred: 'Add to starred',
  removeFromStarred: 'Remove from starred',
  versionHistory: 'Version History',

  // Header status & actions
  refreshingData: 'Refreshing all data...',
  dataRefreshed: 'Data refreshed',
  refreshFailed: 'Refresh failed, please try again',
  processingThumbnails: 'Processing thumbnails in batch...',
  processThumbDone: 'Thumbnails processed: {{processed}} succeeded',
  processThumbDoneWithFailed: 'Thumbnails processed: {{processed}} succeeded, {{failed}} failed',
  processThumbFailed: 'Batch processing failed: {{message}}',
  refreshData: 'Refresh Data',
  processMissingThumbnails: 'Process missing thumbnails',

  // Storage warnings
  storageAlmostFullMsg: 'Storage is almost full! Please free up some space.',
  storageGettingFullMsg: 'Storage is getting full. Consider cleaning up old files.',

  // Category selector
  searchFoldersPlaceholder: 'Search folders…',
  createFolder: 'Create Folder',
  folderNamePlaceholder: 'Folder name',
  nameRequired: 'Name is required',
  nameExists: 'Name already exists at this level',
  createFailed: 'Create failed',

  // Help page
  helpCenter: 'Help Center',
  documentation: 'Documentation',
  documentationDesc: 'Browse our comprehensive guides and documentation',
  videoTutorials: 'Video Tutorials',
  videoTutorialsDesc: 'Watch step-by-step video tutorials',
  communityForum: 'Community Forum',
  communityForumDesc: 'Connect with other users and share knowledge',
  contactSupport: 'Contact Support',
  contactSupportDesc: 'Get help from our support team',
  faq: 'Frequently Asked Questions',
  needMoreHelp: 'Need more help?',
  supportAvailable: 'Our support team is available 24/7 to assist you',
  contactSupportAction: 'Contact Support',
  faqHowUploadQ: 'How do I upload files?',
  faqHowUploadA: 'Click the "Upload" button in the top navigation bar or drag and drop files directly into the application.',
  faqSupportedTypesQ: 'What file types are supported?',
  faqSupportedTypesA: 'We support most common file types including documents, images, videos, and audio files.',
  faqHowShareQ: 'How do I share files with others?',
  faqHowShareA: 'Open the file details and click the "Share" button to generate a sharing link or invite specific users.',
  faqDeletedFilesQ: 'What happens to deleted files?',
  faqDeletedFilesA: 'Deleted files are moved to the Trash where they remain for 30 days before being permanently deleted.',

  // Settings page
  profileSettings: 'Profile Settings',
  savedSuccess: 'Saved successfully',
  editProfile: 'Edit Profile',
  nameLabel: 'Name',
  phoneLabel: 'Phone Number',
  languagePreference: 'Language Preference',
  chinese: 'Chinese',
  english: 'English',
  notSet: 'Not set',
  accountInfo: 'Account Information',
  accountRole: 'Account Role',
  admin: 'Admin',
  userRole: 'User',
  registeredAt: 'Registered At',
  lastPasswordChange: 'Last Password Change',
  changePassword: 'Change Password',

  // Profile page (portal)
  profilePage: {
    loginRequired: 'Please sign in to view your profile',
    backToFiles: 'Back to files',
    nameNotSet: 'Name not set',
    clickToChangeAvatar: 'Click avatar to change',
    uploading: 'Uploading...',
    personalInfo: 'Personal Information',
    edit: 'Edit',
    name: 'Name',
    email: 'Email',
    save: 'Save',
    cancel: 'Cancel',
    passwordSettings: 'Password Settings',
    changePasswordBtn: 'Change Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    newPasswordPlaceholder: 'Enter new password (min. 6 characters)',
    confirmPasswordPlaceholder: 'Re-enter new password',
    updatePassword: 'Update Password',
    passwordHint: 'Click "Change Password" to update your login password',
    accountActions: 'Account Actions',
    signOut: 'Sign Out',
    // Success/Error messages
    profileUpdated: 'Profile updated successfully',
    profileUpdateFailed: 'Failed to update profile, please try again',
    passwordUpdated: 'Password updated successfully',
    passwordUpdateFailed: 'Failed to update password, please try again',
    passwordMismatch: 'New password and confirmation do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    avatarUpdated: 'Avatar updated successfully',
    avatarUpdateFailed: 'Failed to update avatar, please try again',
    signOutFailed: 'Failed to sign out, please try again',
  },
  storageOverviewTitle: 'Storage Overview',
  storageByTypeTitle: 'Storage by File Type',
  storageManagementTitle: 'Storage Management',
  cleanUpAssistantTitle: 'Clean Up Assistant',
  cleanUpAssistantDesc: 'Find and remove duplicate or large files',
  run: 'Run →',
  storageAnalyticsTitle: 'Storage Analytics',
  storageAnalyticsDesc: 'View detailed storage usage analytics',
  view: 'View →',
  upgradeStorageTitle: 'Upgrade Storage',
  upgradeStorageDesc: 'Get more storage space for your files',
  upgrade: 'Upgrade →',
  notificationSettingsTitle: 'Notification Settings',
  notificationSettingsDesc: 'Configure your notification preferences here.',
  securitySettingsTitle: 'Security Settings',
  securitySettingsDesc: 'Manage your security and privacy settings.',
  sharingCollabTitle: 'Sharing & Collaboration',
  sharingCollabDesc: 'Configure sharing and collaboration settings.',
  trashManagementTitle: 'Trash Management',
  trashManagementDesc: 'Manage your deleted files and recovery options.',
  settingsMenu: {
    profile: 'Profile',
    storage: 'Storage Management',
    notifications: 'Notifications',
    security: 'Security',
    sharing: 'Sharing & Collaboration',
    trash: 'Trash Management',
  },

  // Portal - Portal page
  portal: {
    title: 'Unilumin File Resource Portal',
    titleShort: 'File Portal',
    loginToSeeMore: 'Login to see more',
    adminPanel: 'Admin Panel',
    collaborativeWhiteboard: 'Collaborative Whiteboard',
    admin: 'Admin',
    userProfile: 'My Profile',
    logout: 'Sign Out',
    allFiles: 'All Files',
    orderQuery: 'Order Query',
    folders: 'Folders',
    searchPlaceholder: 'Search files, order numbers, folders...',
    allTypes: 'All Types',
    batchActions: 'Batch Actions',
    preview: 'Preview',
    download: 'Download',
    gridView: 'Grid View',
    listView: 'List View',
    noResults: 'No files found',
    tryDifferentKeyword: 'Try a different search term',
    // Sidebar related
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    favorites: 'Favorites',
    unfavorite: 'Unfavorite',
    favorite: 'Favorite',
    noFolders: 'No folders',
    // Filter related
    activeFilters: 'Active Filters',
    clearFilters: 'Clear',
    folder: 'Folder',
    // Visibility labels
    visibilityPublic: 'Public',
    visibilityRestricted: 'Restricted',
    visibilityPrivate: 'Private',
    // Order query
    order: 'Order',
    orderNumber: 'Order Number',
    orderNumberInputPlaceholder: 'Enter order number',
    orderPlaceholder: 'Enter order number...',
    searching: 'Searching...',
    searchNow: 'Search Now',
    orderTip: '💡 Enter order number to add to your account',
    orderQueryHint: 'Enter the order number to get temporary access to files',
    queryButton: 'Query',
    querySuccessRedirecting: 'Success! Redirecting...',
    // List headers
    headerName: 'Name',
    headerType: 'Type',
    headerSize: 'Size',
    headerActions: 'Actions',
    headerSelect: 'Select',
    selectedItems: '{{count}} Selected',
    downloadSelected: 'Download Selected',
    // Filter status
    currentFilter: 'Current Filter',
    orderSearch: '📋 Order Search',
    folderSearch: '📁 Folder Search',
    fileSearch: '📄 File Search',
    typeLabel: 'Type',
    folderLabel: 'Folder',
    tagsLabel: 'Tags',
    tagsCount: '{{count}} tags',
    noMatchingFiles: 'No matching files found',
    noPublicFiles: 'No public files',
    // Guest status banner
    guestBannerTitle: 'Browsing {{count}} public files',
    guestBannerDescription: 'Sign in to access more files you have permission to view',
    // Batch operations
    exitBatchMode: 'Exit Batch',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    emptyFolder: 'Empty folder',
    nameNotSet: 'Name not set',
    notSet: 'Not set',
    // Navigation and filters
    allFilesHome: 'All Files',
    subfolders: 'Subfolders',
    subfoldersCount: 'Subfolders ({{count}})',
    clearAll: 'Clear All',
    pressEnterToSearch: 'Press Enter to search files',
    searchResults: 'Search Results',
  },

  // Theme - Theme settings
  theme: {
    light: 'Light Mode',
    dark: 'Dark Mode',
    system: 'System',
    switchToLight: 'Switch to Light Mode',
    switchToDark: 'Switch to Dark Mode',
  },

  // Footer
  footer: {
    copyright: 'Unilumin File Management System',
    design: 'Design',
  },

  // Permission levels
  permissions: {
    basic: 'Basic',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    uploader: 'Uploader',
    admin: 'Admin',
    super_admin: 'Super Admin',
    public: 'Public',
  },

  // Common actions
  common: {
    search: 'Search',
    loading: 'Loading...',
    downloading: 'Downloading...',
    error: 'An error occurred',
    retry: 'Please try again later',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    update: 'Update',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    clear: 'Clear',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    noData: 'No data',
    open: 'Open',
    copiedToClipboard: 'Copied to clipboard',
  },

  // Cookie Banner
  cookie: {
    title: 'Privacy & Cookie Preferences',
    description: 'Unilumin values your privacy. We use cookies to enhance your experience, analyze usage, and optimize our services.',
    gdprCompliant: 'GDPR and global privacy compliant',
    customizeSettings: 'Customize Settings',
    essentialOnly: 'Essential Only',
    acceptAll: 'Accept All',
    savePreferences: 'Save Preferences',
    essentialCookies: 'Essential Cookies',
    essentialCookiesDesc: 'Required for the website to function properly, including authentication and security features.',
    analyticsCookies: 'Analytics Cookies',
    analyticsCookiesDesc: 'Help us understand user behavior to optimize product experience and performance.',
    functionalCookies: 'Functional Cookies',
    functionalCookiesDesc: 'Remember your preferences and provide personalized content and services.',
    marketingCookies: 'Marketing Cookies',
    marketingCookiesDesc: 'Used to display relevant advertisements and promotional content.',
  },

  // Tenant Management
  tenant: {
    cn: 'China',
    intl: 'International',
    switchTenant: 'Switch Tenant',
    currentTenant: 'Current Tenant',
    allTenants: 'All Tenants',
    tenantLabel: 'Tenant',
  },
};

export default en;
export type EnLocale = typeof en;



